module.exports = __webpack_public_path__ + "static/media/Werewolf.58a6fa1f.jpg";